import J, { STORAGE_KEYS as i } from "./storage-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
const Mt = {
  xo: function (e, o = !1) {
    let t = !1;
    try {
      if (localStorage && localStorage.getItem)
        try {
          localStorage.setItem(i.k.Qa, "true"),
            localStorage.getItem(i.k.Qa) &&
              (localStorage.removeItem(i.k.Qa), (t = !0));
        } catch (e) {
          if (
            !(
              e instanceof Error &&
              ("QuotaExceededError" === e.name ||
                "NS_ERROR_DOM_QUOTA_REACHED" === e.name) &&
              localStorage.length > 0
            )
          )
            throw e;
          t = !0;
        }
    } catch (e) {
      r.j.info("Local Storage not supported!");
    }
    const a = Mt.Ja(),
      n = new J.Va(e, a && !o, t);
    let c;
    return (c = t ? new J.Ya(e) : new J.Za()), new J(n, c);
  },
  Ja: function () {
    return (
      navigator.cookieEnabled ||
      ("cookie" in document &&
        (document.cookie.length > 0 ||
          (document.cookie = "test").indexOf.call(document.cookie, "test") >
            -1))
    );
  },
};
export default Mt;
